// Mock authentication service

let currentUser = null;
const listeners = [];

const auth = {
    onAuthStateChanged: (callback) => {
        listeners.push(callback);
        callback(currentUser);
        return () => {
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
    }
};

const notifyListeners = () => {
    listeners.forEach(callback => callback(currentUser));
};

const signIn = (email, password) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            if (email && password) {
                let role = 'Teacher'; // Default role
                if (email.toLowerCase() === 'superadmin@example.com') {
                    role = 'SuperAdmin';
                } else if (email.toLowerCase() === 'admin@example.com') {
                    role = 'Admin';
                } else if (email.toLowerCase() === 'student@example.com') {
                    role = 'Student';
                }

                currentUser = { email, role };
                notifyListeners();
                resolve();
            } else {
                reject(new Error('Invalid email or password'));
            }
        }, 500);
    });
};

const logOut = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            currentUser = null;
            notifyListeners();
            resolve();
        }, 500);
    });
};

export { auth, signIn, logOut };
